<template>
    <div class="footer">
        <div class="foot">
            <div class="nav fl">
<!--                <a target="_blank" href="http://home.gsdata.cn/about-us.html">关于清博</a>-->
<!--                <a target="_blank" href="http://home.gsdata.cn/news-report/">清博资讯</a>-->
<!--                <a target="_blank" href="http://home.gsdata.cn/recruiting-talents.html">诚聘英才</a>-->
<!--                <a target="_blank" href="http://databus.gsdata.cn/">开放平台</a>-->
<!--                <a target="_blank" href="http://www.gsdata.cn/site/usage">榜单公式</a>-->
<!--                <a target="_blank" href="http://home.gsdata.cn/cooperation.html">咨询&amp;合作</a>-->
<!--                <a target="_blank" href="http://home.gsdata.cn/contact-us.html">联系我们</a>-->
<!--                <p>©2014-2025 北京清博智能科技有限公司 版权所有&nbsp;&nbsp;京ICP备16036802号-1&nbsp;&nbsp;<img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/beian.png" alt="公安局备案">-->
<!--                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024017" rel="nofollow">-->
<!--                            <span>京公网安备11010802024017号</span>-->
<!--                        </a>-->
<!--                </p>-->
<!--              南阳百可知信息技术咨询有限公司 版权所有&nbsp;-->
              <p> ©2014-2025 &nbsp;豫ICP备2025110501号-1&nbsp;&nbsp;
                <img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/beian.png" alt="公安局备案">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41132602001155" rel="nofollow">
                  <span>豫公网安备41132602001155号</span>
                </a>
              </p>
            </div>
<!--            <div class="foot-imgs fr">-->
<!--                <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qbzs.jpg"><span class="word">清博指数</span></a>-->
<!--                <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qb.jpg"><span class="word">清博舆论</span></a>-->
<!--                <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qbdsj.jpg"><span class="word">清博智能</span></a>-->
<!--            </div>-->
        </div>
    </div>
    <!-- <div class="footer footer1">
        <div class="foot">
            <div class="nav1 ac">
                <p>©2014-2017 北京清博智能科技有限公司 版权所有&nbsp;&nbsp;京ICP备16036802号-1&nbsp;&nbsp;<img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/beian.png" alt="公安局备案">
                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024017" rel="nofollow">
                            <span>京公网安备11010802024017号</span>
                        </a>
                </p>
            </div>
        </div>
    </div> -->
</template>
<script>
export default {
    data() {
        return {s

        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
            //that.dataAjax();
        })
    },
    methods: {

    }
}
</script>
<style lang="" scope>
    .footer{width:100%;height:70px;background:#363c4b;}
    .footer.curr{position:fixed;bottom:0;left:0;}
    .footer .foot{width:1200px;height:100%;margin:0 auto;}
    .footer .foot .nav{width: 100%;font-size:16px;line-height: 70px;text-align: center;}
    .footer .foot .nav a{color:#7a8599;display:inline-block;margin-right:15px;margin-bottom:18px;}
    .footer .foot .nav p{color:#7a8599;font-size:12px;margin:0;}
    .footer .foot .nav p a{margin:0;}
    .foot .nav img,.footer1 .nav1 img{vertical-align: middle}
    .footer .foot-imgs{margin:35.5px auto 0;}
    .footer .foot-imgs a{color:#7a8599;float:left;margin-right:36px;}
    .footer .foot-imgs a img{width:83px;height:83px;}
    .footer .foot-imgs a .word{display:block;text-align:center;margin-top:8px;}
    .footer1{height:48px;padding-top:13px;}
    .footer1 .nav1 a,.footer1 .nav1 p{color:#7a8599;}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue